import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../utils/animations';

export default function StatCard({ value, label }) {
  return (
    <motion.div
      variants={fadeUp}
      whileHover={{ y: -5, scale: 1.02 }}
      transition={{ duration: 0.3 }}
      className="rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur-md cursor-default hover:bg-white/10 hover:border-white/20 hover:shadow-[0_8px_30px_rgb(0,0,0,0.12)] hover:shadow-blue-500/10 transition-colors"
    >
      <div className="text-3xl font-semibold text-white md:text-4xl">{value}</div>
      <div className="mt-2 text-sm uppercase tracking-[0.18em] text-white/60">{label}</div>
    </motion.div>
  );
}